import React from 'react'
import { Routes, Route, Link } from "react-router-dom";
import Edata from '../Data/Edata'
function Entertainment() {
  return (
    <div>
        <div className="container">
          <div className="row pt-2 px-3 mb-5">
            {Edata.map((a) => (
              <div className="col-lg-12 mt-5">
                <div className="mb-5 mx-3 entertop p-2">
                  <img className="w-100 owl health" src={a.img} />
                  <div className="card-body">
                    <p className=" fw-bold text-danger pt-3">MUSIC</p>
                    <a href="#"><Link to={`/details/${a.id}`}><h6 className="fw-bold enter text-start">{a.title}</h6>
                    </Link>
                      <p className='text-secondary py-2 fs-5'>{a.des}</p>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
  </div>
  )
}

export default Entertainment
